import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eforms-content-table',
  templateUrl: './eforms-content-table.component.html',
  styleUrls: ['./eforms-content-table.component.scss']
})
export class EformsContentTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
